import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { COACH, FEED_REPORT, PAGE_LIMIT } from "helpers/viewContent";
import { FORMAT_TEXT, DATE_FORMAT, DATE_FORMAT_TIME } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { DELETE_ALERT } from "helpers/constantsMessage";
import { PRODUCT_IMG } from "utils/constant";
import ContentLoader_ from "helpers/ContentLoader_";
//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getList_, deleteData_, updateData_ } from "store/services/commonService";

const Listing = ({
  dispatch,
  itemsCountPerPage,
  totalItemsCount,
}) => {
  const [activePage, setActivePage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [role, setRole] = useState("");
const [selectedItem, setSelectedItem] = useState(null);
const handleViewDetails = (item) => {
  setSelectedItem(item);
  setShowModal(true);
};
  const [listing, setListing] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  let timeout;

  const debounced = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  const fetchData = async () => {
    try {
      let query = {
        url: "postReports/listPostReports",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        search_string: searchValue,
          role: role,

      };

      setIsLoading(true);

      dispatch(actions.persist_store({ loader: false }));

      let res = await dispatch(getList_(query));

      setListing(res?.body?.data || []);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activePage,role]);

  const handleSearchChange = (event) => {
    const inputValue = event.target.value;

    setSearchValue(inputValue);

    if (inputValue.length >= 3 || inputValue.length === 0) {
      debounced(() => {
        fetchData();
      }, 800);
    }
  };

  const clearSerchFilter = () => {
  setSearchValue("");
  setRole("");
  setActivePage(1);
};

  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Helmet title={FEED_REPORT.CURRENT_MODULE} />

      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-flag menu-icon"></i>
          </span>
          {FEED_REPORT.CURRENT_MODULE}
        </h3>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.feed}>
                {FEED_REPORT.CURRENT_MODULE}
              </Link>
            </li>

            <li
              className="breadcrumb-item active"
              aria-current="page"
            >
              Listing
            </li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row align-items-center">
                  <div className="col-md-4">Listing</div>

                 <div className="col-md-8">
  <div className="row">
    <div className="col-md-8">
      <div className="add-items d-flex">
        {/* <input
          className="form-control"
          autoComplete="off"
          type="text"
          placeholder="Search by user name/email/post"
          value={searchValue}
          onChange={handleSearchChange}
        /> */}

        {/* <button
          type="button"
          className="btn btn-outline-danger btn-sm ms-2"
          onClick={clearSerchFilter}
        >
          <i className="mdi mdi-close-circle"></i>
        </button> */}
      </div>
    </div>

    <div className="col-md-4">
      <select
        className="form-control"
        value={role}
        onChange={(e) => {
          setRole(e.target.value);
          setActivePage(1);
        }}
      >
        <option value="">All User Types</option>
        <option value="1">User</option>
        <option value="2">Coach</option>
      </select>
    </div>
  </div>
</div>
                </div>
              </h4>

              <div className="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Post Image</th>
                      <th>Post Description</th>
                      <th>Report Reason</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan="9">
                          <div className="loader-class">
                            <ContentLoader_ />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {listing.length > 0 ? (
                        listing.map((list, i) => {
                          return (
                            <tr key={i}>
                              {/* USER IMAGE */}
                              <td>
                                <a
                                  href={
                                    list?.reported_by_user
                                      ?.image_thumb || "#"
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    src={
                                      list?.reported_by_user
                                        ?.image_thumb ||
                                      PRODUCT_IMG
                                    }
                                    alt="user"
                                    className="custom-img"
                                  />
                                </a>
                              </td>

                              {/* NAME */}
                              <td>
                                {list?.reported_by_user?.name
                                  ? FORMAT_TEXT(
                                      list?.reported_by_user?.name
                                    )
                                  : "N/A"}
                              </td>

                              {/* EMAIL */}
                              <td>
                                {list?.reported_by_user?.email
                                  ? FORMAT_TEXT(
                                      list?.reported_by_user?.email
                                    )
                                  : "N/A"}
                              </td>

                              {/* POST IMAGE */}
                              <td>
                                <a
                                  href={list?.post?.media || "#"}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    src={
                                      list?.post?.thumb ||
                                      PRODUCT_IMG
                                    }
                                    alt="post"
                                    className="custom-img"
                                  />
                                </a>
                              </td>

                              {/* POST DESCRIPTION */}
                              <td style={{ minWidth: "220px" }}>
                                {list?.post?.description
                                  ? FORMAT_TEXT(
                                      list?.post?.description
                                    )
                                  : "N/A"}
                              </td>

                              {/* REPORT DESCRIPTION */}
                              <td style={{ minWidth: "180px" }}>
                                {list?.description
                                  ? FORMAT_TEXT(
                                      list?.description
                                    )
                                  : "N/A"}
                              </td>

                              {/* STATUS */}
                              <td>
                                <label
                                  className={`badge badge-gradient-${
                                    list?.status === "1"
                                      ? "success"
                                      : "danger"
                                  }`}
                                >
                                  {list?.status === "1"
                                    ? "Active"
                                    : "Inactive"}
                                </label>
                              </td>

                              {/* CREATED */}
                              <td>
                                {list?.created_at
                                  ? DATE_FORMAT_TIME(
                                      list?.created_at
                                    )
                                  : "N/A"}
                              </td>

                              {/* ACTION */}
                              <td>
  <label
    className="btn btn-sm btn-gradient-info"
    style={{ cursor: "pointer" }}
    title="View"
    onClick={() => handleViewDetails(list)}
  >
    <i className="mdi mdi-eye"></i>
  </label>
</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            No data found...
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </table>
              </div>

              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title>Report Details</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedItem && (
      <div className="container-fluid">
        <div className="row">
          {/* USER INFO */}
          <div className="col-md-6 mb-4">
            <h5 className="mb-3">Reported By</h5>

            <div className="text-center mb-3">
              <img
                src={
                  selectedItem?.reported_by_user?.image_thumb ||
                  PRODUCT_IMG
                }
                alt="user"
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            </div>

            <p>
              <strong>Name :</strong>{" "}
              {selectedItem?.reported_by_user?.name || "N/A"}
            </p>

            <p>
              <strong>Email :</strong>{" "}
              {selectedItem?.reported_by_user?.email || "N/A"}
            </p>
            <p>
  <strong>User Type :</strong>{" "}
  {selectedItem?.reported_by_user?.role === "1"
    ? "User"
    : selectedItem?.reported_by_user?.role === "2"
    ? "Coach"
    : "N/A"}
</p>

            <p>
              <strong>User ID :</strong>{" "}
              {selectedItem?.reported_by_user?.id || "N/A"}
            </p>
          </div>

          {/* POST INFO */}
          <div className="col-md-6 mb-4">
            <h5 className="mb-3">Post Details</h5>

            <div className="text-center mb-3">
              <img
                src={selectedItem?.post?.thumb || PRODUCT_IMG}
                alt="post"
                style={{
                  width: "150px",
                  height: "150px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            </div>

            <p>
              <strong>Post ID :</strong>{" "}
              {selectedItem?.post?.id || "N/A"}
            </p>

            <p>
              <strong>Description :</strong>{" "}
              {selectedItem?.post?.description || "N/A"}
            </p>
          </div>

          {/* REPORT DETAILS */}
          <div className="col-md-12">
            <hr />

            <h5 className="mb-3">Report Information</h5>

            <p>
              <strong>Reason :</strong>{" "}
              {selectedItem?.description || "N/A"}
            </p>

            <p>
              <strong>Status :</strong>{" "}
              <span
                className={`badge badge-${
                  selectedItem?.status === "1"
                    ? "success"
                    : "danger"
                }`}
              >
                {selectedItem?.status === "1"
                  ? "Active"
                  : "Inactive"}
              </span>
            </p>

            <p>
              <strong>Created At :</strong>{" "}
              {selectedItem?.created_at
                ? DATE_FORMAT_TIME(selectedItem?.created_at)
                : "N/A"}
            </p>

            <p>
              <strong>Updated At :</strong>{" "}
              {selectedItem?.updated_at
                ? DATE_FORMAT_TIME(selectedItem?.updated_at)
                : "N/A"}
            </p>

            {selectedItem?.post?.media && (
              <p>
                <strong>Media :</strong>{" "}
                <a
                  href={selectedItem?.post?.media}
                  target="_blank"
                  rel="noreferrer"
                >
                  View Media
                </a>
              </p>
            )}
          </div>
        </div>
      </div>
    )}
  </Modal.Body>
</Modal>
      </div>
    </>
  );
};


const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
